import { render, staticRenderFns } from "./carpsaleEditPage.vue?vue&type=template&id=47676a28&"
import script from "./carpsaleEditPage.vue?vue&type=script&lang=ts&"
export * from "./carpsaleEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports